import { render } from "./Set-Backup.vue?vue&type=template&id=2d96c302"
import script from "./Set-Backup.vue?vue&type=script&lang=js"
export * from "./Set-Backup.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Vue_Webinterface\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__